const type = 'INCREMENT_DISPLAY_COUNT';

const incrementDisplayCount = () => ({
  type,
});

export { type };
export default incrementDisplayCount;
